function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["id", "onClick", "size", "outline", "variant", "disabled", "icon", "as", "isLoading", "buttonProps", "badge", "children", "className", "style"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { noop } from "lodash-es";
import { useIcon } from "../../helpers";
var Button = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$id = _ref.id,
    id = _ref$id === void 0 ? "" : _ref$id,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? noop : _ref$onClick,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "md" : _ref$size,
    _ref$outline = _ref.outline,
    outline = _ref$outline === void 0 ? false : _ref$outline,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "primary" : _ref$variant,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? {
      type: "",
      render: undefined
    } : _ref$icon,
    _ref$as = _ref.as,
    AsComponent = _ref$as === void 0 ? "button" : _ref$as,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    _ref$buttonProps = _ref.buttonProps,
    buttonProps = _ref$buttonProps === void 0 ? {} : _ref$buttonProps,
    _ref$badge = _ref.badge,
    badge = _ref$badge === void 0 ? {
      type: "",
      render: undefined
    } : _ref$badge,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    props = _objectWithoutProperties(_ref, _excluded);
  var iconToRender = useIcon(icon.render);
  var ButtonComponent = disabled ? "button" : AsComponent;
  var btnProps = _objectSpread({}, buttonProps);
  btnProps.type = btnProps.type || (ButtonComponent === "button" ? "button" : undefined);
  return /*#__PURE__*/React.createElement("span", _extends({}, props, {
    ref: ref,
    id: id,
    role: "button",
    className: "button-wrapper ".concat(className),
    tabIndex: disabled ? "-1" : "0",
    style: _objectSpread({
      display: "inline-block"
    }, style),
    onKeyPress: function onKeyPress(e) {
      if (e.key === "Enter" && !disabled) {
        onClick(e);
      }
    }
  }), /*#__PURE__*/React.createElement(ButtonComponent, _extends({}, btnProps, {
    tabIndex: "-1",
    className: classNames("tui-btn ".concat(size, " ").concat(variant), {
      outline: outline,
      "icon-only": children === null,
      "icon-left": icon.type === "left",
      "icon-right": icon.type === "right"
    }),
    onClick: !disabled ? onClick : undefined,
    disabled: disabled || isLoading,
    "aria-busy": isLoading
  }), /*#__PURE__*/React.createElement("span", {
    className: "tui-btn-content"
  }, icon.type !== "right" && iconToRender, badge.type !== "right" && badge.render, children, icon.type === "right" && iconToRender, badge.type === "right" && badge.render, isLoading && /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    className: "loading-spinner"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "50",
    cy: "50",
    r: "45",
    className: "spinner"
  })))));
});
Button.displayName = "Button";
Button.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.object,
  size: PropTypes.string,
  outline: PropTypes.bool,
  variant: function variant(_ref2, _key, componentName, _location, propFullName) {
    var _variant = _ref2.variant,
      outline = _ref2.outline;
    if (_variant == null) {
      return null;
    }
    if (typeof _variant !== "string") {
      return Error("Invalid prop ".concat(propFullName, " supplied to ").concat(componentName, ". Expected a string."));
    }
    if (outline && _variant === "white") {
      return Error("Outline buttons do not have a \"white\" variant");
    }
  },
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  icon: PropTypes.shape({
    type: PropTypes.string,
    render: PropTypes.func
  }),
  badge: PropTypes.shape({
    type: PropTypes.string,
    render: PropTypes.element
  }),
  children: PropTypes.node,
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
  buttonProps: PropTypes.object
};
export default Button;
//# sourceMappingURL=Button.js.map